import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import ContactModel from "@/commons/models/Contact";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 問い合わせ API 操作クラス
 */
export default class Contacts {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET Contacts
   */
  public async get(
    userStore: LoginUser,
    queryParams: {
      startIndex: number;
      endIndex: number;
      order: string;
    }
  ): Promise<Array<ContactModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Contacts, formatParams);
    const response = await this.commonService.executeGet<Array<ContactModel>>(userStore, requestUrl, this.constructor.name, queryParams, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * GET OpinionsCount
   */
  public async getCount(userStore: LoginUser, errorType: HitomeqErrorType, queryParams?: { confirmed: boolean }): Promise<number> {
    // countの場合は末尾に「count」をつける
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Contacts, formatParams);
    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<{ count: number }>(userStore, `${requestUrl}/count`, this.constructor.name, params, errorType, 0);

    return response.data.count;
  }

  /**
   * POST Contacts
   */
  public async post(userStore: LoginUser, contact: ContactModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Contacts, formatParams);

    // APIのモデルに合わせてここで送信内容を調整
    const requestBody: any = {
      userId: contact.userId,
      type: Number(contact.type),
      contactMethod: Number(contact.contactMethod),
      customerName: contact.customerName,
      customerKana: contact.customerKana,
      customerTel: contact.customerTel,
      customerMail: contact.customerMail,
      message: contact.message
    };

    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * PATCH Contacts
   */
  public async patch(userStore: LoginUser, caseId: number, contact: ContactModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      caseId: caseId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.ContactMessages, formatParams);

    // APIのモデルに合わせてここで送信内容を調整
    const requestBody: any = {
      confirmed: contact.confirmed
    };

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
